import { useRef, useEffect, useState } from 'react';
import { Box, CssBaseline } from '@mui/material';
import TopNavigationBar from '../pages/navigator/TopNavigationBar';
import Footer from '../compontents/common/Footer';
import {motion} from 'framer-motion';

import { Outlet } from 'react-router-dom';

import { ScrollToTop } from '../compontents/common/ScrollToTop';

export function Layout() {
    const navRef = useRef<HTMLDivElement>(null);
    const topFooterRef = useRef<HTMLDivElement>(null);
    const [overFooter, setOverFooter] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (topFooterRef.current && navRef.current) {
                const sentinelRect = topFooterRef.current.getBoundingClientRect();
                const navRect = navRef.current.getBoundingClientRect();
                setOverFooter(navRect.top >= sentinelRect.bottom);
            }
        };

        window.addEventListener('scroll', handleScroll);
        window.addEventListener('resize', handleScroll);
        handleScroll();

        return () => {
            window.removeEventListener('scroll', handleScroll);
            window.removeEventListener('resize', handleScroll);
        };
    }, []);


    return (
        <Box
            sx={{background: 'rgb(17, 17, 17)',}}
        >
            <ScrollToTop />
            
            <motion.div
                key={location.pathname}
                initial={{ opacity: 0, y: 40 }}         
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, ease: "linear" }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: '100%',
                        minHeight: '100vh',
                    }}
                >
                    <CssBaseline />

                    <TopNavigationBar navRef={navRef} overFooter={overFooter} setOverFooter={setOverFooter} />

                    <Box component="main" sx={{ flexGrow: 1, width: '100%' }}>
                        <Outlet />
                    </Box>
                    
                    <div ref={topFooterRef} style={{ height: 1, width: '100%', opacity: 0, pointerEvents: 'none' }} />
                    <Footer />
                </Box>
            </motion.div>
        </Box>
    );
}